import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
const CALENDAR_EVENTS = [{
  id: "02",
  title: "Archival Exhibition: The 1838 Ships",
  date: "November 5, 2026",
  location: "Port Louis, Mauritius",
  type: "Exhibition"
}, {
  id: "03",
  title: "Genealogy & Lineage Workshop",
  date: "December 12, 2026",
  location: "Virtual Event",
  type: "Workshop"
}, {
  id: "04",
  title: "Girmitiya Heritage Gala",
  date: "January 20, 2027",
  location: "New Delhi, India",
  type: "Ceremony"
}, {
  id: "05",
  title: "Documenting the Caribbean Diaspora",
  date: "March 15, 2027",
  location: "Georgetown, Guyana",
  type: "Symposium"
}];
const EventCalendar = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div><h2 className="font-display text-[32px] sm:text-[44px] md:text-[52px] lg:text-[64px] text-[#F4EFE6] leading-none mb-3 sm:mb-4">Official Calendar</h2><p className="font-body text-[13px] sm:text-[16px] text-white/50 font-light max-w-[500px] leading-[1.7]">A comprehensive schedule of upcoming symposiums, exhibitions, and cultural gatherings worldwide.</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="font-body text-[10px] tracking-[0.2em] uppercase text-[#DF6D2A]">Filter by:</span>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col md:flex-row md:items-end justify-between gap-5 sm:gap-8 mb-10 sm:mb-14 md:mb-20 border-b border-[#F4EFE6]/10 pb-6 sm:pb-8">{t0}<div className="flex items-center gap-4">{t1}<select className="bg-transparent border border-white/20 text-[#F4EFE6] font-body text-[12px] uppercase px-4 py-2 outline-none appearance-none cursor-pointer"><option value="all">All Event Types</option><option value="symposium">Symposiums</option><option value="exhibition">Exhibitions</option><option value="workshop">Workshops</option></select></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section className="bg-[#0F1C2E] py-16 sm:py-24 md:py-32 relative overflow-hidden"><div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-12">{t2}<div className="flex flex-col"><div className="hidden md:grid grid-cols-12 gap-6 pb-6 border-b border-[#F4EFE6]/10"><div className="col-span-3 font-body text-[10px] tracking-[0.2em] uppercase text-white/40">Date</div><div className="col-span-7 font-body text-[10px] tracking-[0.2em] uppercase text-white/40">{"Event Title & Location"}</div><div className="col-span-2 font-body text-[10px] tracking-[0.2em] uppercase text-white/40">Type</div></div>{CALENDAR_EVENTS.map(_temp)}</div></div></section>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default EventCalendar;
function _temp(event, idx) {
  return <motion.div key={event.id} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay: idx * 0.1
  }} className="grid grid-cols-1 md:grid-cols-12 gap-3 sm:gap-4 md:gap-6 items-start md:items-center py-6 sm:py-8 md:py-10 border-b border-[#F4EFE6]/10 group hover:bg-[#F4EFE6]/5 transition-colors px-3 sm:px-4 -mx-3 sm:-mx-4 rounded-sm"><div className="col-span-1 md:col-span-3"><span className="font-display text-[20px] sm:text-[24px] md:text-[28px] text-[#C9A84C] group-hover:text-[#F4EFE6] transition-colors">{event.date}</span></div><div className="col-span-1 md:col-span-7"><h3 className="font-display text-[22px] sm:text-[26px] md:text-[30px] lg:text-[36px] text-[#F4EFE6] leading-tight mb-1 sm:mb-2 group-hover:text-[#DF6D2A] transition-colors">{event.title}</h3><div className="flex items-center gap-2"><div className="w-1.5 h-1.5 rounded-full bg-white/20" /><span className="font-body text-[12px] sm:text-[13px] tracking-wide text-white/50">{event.location}</span></div></div><div className="col-span-1 md:col-span-2"><span className="font-body text-[11px] tracking-[0.15em] uppercase px-3 py-1.5 border border-white/20 text-white/60 rounded-full inline-block">{event.type}</span></div></motion.div>;
}